<template>
    <v-container>
        <v-row class="mt-4 text-h6" justify="center">
            <v-col cols="10" xl="8">
                <div class="heading text-h4 pl-4">学生の声</div>
            </v-col>
        </v-row>
        
        <div class="chat-container">
            <div class="chat-messages">
                <!-- チャットメッセージを表示するループ -->
                <div v-for="(message, index) in messages" :key="index" :class="message.type === 'user' ? 'user-message' : 'bot-message'">
                    {{ message.text }}
                </div>
            </div>
        </div>

    </v-container>
</template>

<script>
import voices from './data/voices.js'
export default {
  data() {
    return {
      messages: voices.messages,
    };
  },
};
</script>

<style scoped>
.heading {
  border-bottom: 2px solid #000;
}

.chat-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.chat-messages {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.user-message {
  background-color: #f0f0f0;
  color: #333;
  align-self: flex-end;
  padding: 10px;
  border-radius: 10px;
  max-width: 70%;
}

.bot-message {
  background-color: #002884;
  color: #fafafa;
  align-self: flex-start;
  padding: 10px;
  border-radius: 10px;
  max-width: 70%;
}
</style>
